const FOCUSABLE = 'input, select, textarea, button, a[href], [tabindex]:not([tabindex="-1"])';

/** The control that follows `from` in tab order, skipping anything disabled —
 *  for a code + name pair that moves on past its name once a code fills it. */
export function nextFocusable(from: HTMLElement): HTMLElement | null {
  const all = Array.from(document.querySelectorAll<HTMLElement>(FOCUSABLE)).filter(
    (el) => !el.hasAttribute('disabled') && el.tabIndex >= 0,
  );
  const at = all.indexOf(from);
  return at >= 0 ? (all[at + 1] ?? null) : null;
}
